<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-md-6">
            <h2>Meus Projetos</h2>
          </div>
          <div class="col-md-2">
            <router-link to="/create-project" class="btn create-project">Criar novo projeto</router-link>
          </div>
        </div>
        <div class="row" v-if="user">
          <div class="projects-list" v-if="projects && projects.length > 0">
            <div class="row project" v-for="project in projects" :key="project.ProjectId">
              <div class="col-md-4">
                <div class="cover">
                  <img v-if="project.Info.image && project.Info.image.length > 0 && project.Info.image.search('via.placeholder.com') == -1" :src="project.Info.image"/>
                  <img v-else src="https://via.placeholder.com/400x400?text=Sem+Foto"/>
                  <div class="info">
                    <h2>{{project.Info.title}}</h2>
                    <span v-if="hasDonations(project)">
                      <b>{{getDonationsValue(project)}}</b> de {{getDonationsCount(project)}} doador(es)
                    </span>
                    <span v-else>
                      Nenhum valor arrecadado.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="row">
                  <span :class="'visibility-'+ project.visibility">{{getVisibility(project.visibility)}}</span>
                  <span v-if="project.projectUnallowed" class="visibility-unallowed" @click="showAlert(project)">Rejeitado</span>
                  <span v-if="!project.projectUnallowed" class="visibility-allowed">Aprovado</span>
                  <span v-if="project.UserId !== user.UserId" class="visibility">Permissão para editar</span>
                </div>
                <div class="row">
                  <router-link class="btn" :to="'/project/manage/' + project.slug" >Editar Projeto</router-link>
                  <router-link class="btn" :to="'/project/manage/' + project.slug + '?tab=activities'" >Adicionar Atividade</router-link>
                  <router-link class="btn" :to="'/project/' + project.slug" >Ver Projeto</router-link>
                  <button v-if="project.UserId == user.UserId" class="btn btn-danger" @click.stop.prevent="deleteProject(project)" >Excluir</button>
                </div>
                <div class="row">
                  <button @click.stop.prevent="facebookShare(project)" class="btn facebook-share">Compartilhe <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /></button>
                  <button @click.stop.prevent="whatsappShare(project)" class="btn whatsapp-share">Compartilhe <font-awesome-icon :icon="['fab', 'whatsapp']" size="lg" /></button>
                </div>
                <div class="row">
                  <input :id="'project-' + project.ProjectId" class="share-link" type="text" readonly :value="'https://click2giv.com/' + getShortUrl(project)" />
                  <button class="share-button btn" @click="copyToClipboard(project.ProjectId)">Copiar</button>
                </div>
                <div class="row">
                  <div class="qr-code" @click.stop.prevent="downloadQrCode('https://click2giv.com/' + project.slug)">
                    <p>Clique com o botão direito e salve o QR code como imagem:</p>
                    <qrcode :value="'https://click2giv.com/' + project.slug" :options="{ width: 120 }"></qrcode>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h4 class="projects-empty" v-if="projects && projects.length == 0">Você não possui projeto. Que tal criar um? =)</h4>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading" message="Aguarde, carregando lista de projetos..."></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
  name: 'MyProjects',
  components: {
    Header,
    Footer,
    Loading,
    FontAwesomeIcon
  },
  data () {
    return {
      user: null,
      projects: null,
      loading: true
    }
  },
  mounted (){
    this.getProfile()
  },
  methods: {
    getProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((result) => {
        this.user = result.body.user;
        this.projects = result.body.user.projects;
        this.getProjects();
      }, (err) => {
        auth.logout();
        this.$router.push('/login');
      });
    },
    getProjects(){
      this.$http.get(API.Profile.projects, {headers: auth.getHeaders()}).then((result) => {
        this.loading = false;
        this.projects = result.body.projects
      });
    },
    getVisibility(visibility){
      switch(visibility){
        case 'public':
          return 'Público';
          break;
        case 'private':
          return 'Privado';
          break;
        case 'inactive':
          return 'Inativo';
          break;
      }
    },
    hasDonations(project){
      var count = 0;
      if(project.Donations){
        project.Donations.map((d) => {
          if(d.paymentStatus && d.paymentStatus == 'paid'){
            count++;
          }
        })
      }
      if(count > 0){
        return true;
      }
      return false;
    },
    getDonationsCount(project){
      var count = 0;
      if(project.Donations){
        project.Donations.map((d) => {
          if(d.paymentStatus && d.paymentStatus == 'paid'){
            count++;
          }
        })
      }
      return count;
    },
    getDonationsValue(project){
      var value = 0.0;
      if(project.Donations){
        project.Donations.map((d) => {
          if(d.value && d.paymentStatus == 'paid'){
            value += parseFloat(d.value);
          }
        })
      }
      return this.convertToReal(value)
    },
    getShortUrl(project)
    {
      return (project.shortUrlToken) ? project.shortUrlToken : project.slug;
    },
    deleteProject(project){
      var r = confirm("Deseja realmente excluir este projeto? Após esta ação, o projeto não poderá mais ser recuperado.")
      if(r == true){
        this.loading = true;
        this.$http.post(API.Projects.updateProject + project.ProjectId, {page: 'deleteProject'}, {headers: auth.getHeaders()}).then((res) => {
          this.getProjects();
        });
      }
    },
    facebookShare(project){
      FB.ui({
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
          object: {
            'og:url': 'https://click2giv.com/project/' + project.slug,
            'og:title': project.Info.title,
            'og:description': project.Info.shortDescription,
            'og:image': project.Info.image
          }
        })
      }, function(response){});
    },
    whatsappShare(project){
      var url = "http://click2giv.com/" + project.slug;
      window.location.href = "whatsapp://send?text=" + url;
    },
    convertToReal(value){
      value = parseFloat(value)
      if(value){
        return Functions.numberToReal(value)
      }
      return value;
    },
    copyToClipboard(ProjectId){
      var copyText = document.getElementById("project-" + ProjectId);
      copyText.select();
      document.execCommand("copy");
    },
    downloadQrCode(qrcode){

    },
    showAlert(project)
    {
      if(project.projectUnallowedMessage){
        alert(project.projectUnallowedMessage);
      }else{
        alert('Seu projeto foi rejeitado. Contate nossa equipe para mais informações.');
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#main{
  padding-bottom: 90px;
}
h2{
  color: #00AE39;
  font-family: RalewayRegular;
}
.create-project{
  color: #fff;
  background-color: #00AE39;
  text-decoration: none;
  &:hover{
    background-color: #333;
  }
}

.projects-empty{
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}

.projects-list{
  .project{
    margin-top: 30px;

    .visibility-public, .visibility{
      background-color: #00AE39;
      color: #fff;
      padding: 15px;
      border-radius: 5px;
      margin-right: 10px;
    }

    .visibility-private{
      background-color: #ffb400;
      color: #fff;
      padding: 15px;
      border-radius: 5px;
      margin-right: 10px;
    }

    .visibility-inactive{
      background-color: red;
      color: #fff;
      padding: 15px;
      border-radius: 5px;
      margin-right: 10px;
    }

    .visibility-allowed{
      background-color: #00AE39;
      color: #fff;
      padding: 15px;
      border-radius: 5px;
      margin-right: 10px;
    }

    .visibility-unallowed{
      background-color: red;
      color: #fff;
      padding: 15px;
      border-radius: 5px;
      margin-right: 10px;
      cursor: pointer;
    }

    .btn{
      border: thin solid #00AE39;
      color: #00AE39;
      margin-right: 10px;
      margin-top: 10px;

      &:hover{
        color: #fff;
        background-color: #00AE39;
      }

      &.facebook-share{
        background-color: #3b5998;
        color: #fff;
        border: none;
        padding: 10px;
        font-size: 24px;
      }

      &.whatsapp-share{
        padding: 10px;
        font-size: 24px;
      }

      &.btn-danger{
        color: #fff;
        border: thin solid #c82333;

        &:hover{
          color: #fff;
          background-color: red;
        }
      }
    }

    .qr-code{
      cursor: pointer;

      p{
        margin-top: 10px;
        margin-bottom: 0px;
      }
    }
  }
  .cover{
    border: thin solid #ccc;
    border-radius: 5px;
    padding-bottom: 10px;

    img{
      width: 100%;
    }
    .info{
      h2{
        font-size: 22px;
        font-family: RalewayRegular;
        margin-top: 10px;
        margin-left: 10px;
      }
      span{
        margin-left: 10px;
      }
    }
  }

  .share-link{
    width: 80%;
    margin-top: 20px;
    padding: 10px;
    border-radius: 5px;
    border: thin solid #ccc;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  .share-button{
    background-color: #00AE39;
    color: #fff !important;
    margin-top: 20px !important;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyProjects.vue